<template>
  <div
    v-b-toggle="[toggleId]"
    class="pap-form__form-subhead--with-icon general-panel--focus-off"
    :class="togglePanelClass"
  >
    <!-- <i :class="togglePanelIconClass" class="mr-2"></i> <slot></slot> -->
    <i :class="togglePanelIconClass" class="mr-2"></i>
    <slot v-bind:togglerText="togglerText"> {{ togglerText.display }} </slot>
  </div>
</template>

<script>
export default {
  name: 'ToggleControl',
  props: ['toggleId', 'closedText', 'openText', 'toggleClass'],

  data: function () {
    return {
      togglePanelCollapsed: true,
      iconClassCollapsed: 'fas fa-angle-down',
      iconClassExpanded: 'fas fa-angle-up',
    };
  },

  computed: {
    togglerText: function () {
      var obj = {
        closedText: this.closedText,
        openText: this.openText,
      };
      obj.display = this.togglePanelCollapsed
        ? this.closedText
        : this.openText === '[same]'
        ? this.closedText
        : this.openText;
      return obj;
    },
    togglePanelClass: function () {
      var classObj = {};
      if (this.toggleClass !== '') {
        classObj[this.toggleClass] = true;
      }
      return classObj;
    },
    togglePanelIconClass: function () {
      var classObj = {};
      classObj[this.iconClassCollapsed] = this.togglePanelCollapsed;
      classObj[this.iconClassExpanded] = !this.togglePanelCollapsed;
      return classObj;
    },
  },
  methods: {
    toggleText: function () {
      this.togglerText.display = this.togglePanelCollapsed
        ? this.togglerText.closedText
        : this.togglerText.openText;
    },
  },
  mounted: function () {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId === this.toggleId) {
        this.togglePanelCollapsed = isJustShown ? false : true;
      }
    });
  },
};
</script>

<style>
</style>